import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { Tables } from "@msuite/utils/types";
import React from "react";
import { EditDefaultApproversModal } from "@/modals/incoming-invoices/edit-default-approvers-modal";
import { EditWorkspaceModal } from "@/modals/organizations/edit-workspace-modal";

export function RowActions({
	cell,
}: CellContext<
	Tables<"workspaces"> & {
		_meta?: Tables<"workspaceMeta">;
	},
	"actions"
>) {
	/** Hooks */
	const editWorkspaceModal = useDisclosure();
	const editDefaultApproversModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<RowActionsWrapper to={null}>
				<Button
					icon={<Icon name="UserCheck" />}
					size="xxs"
					variant="ghost"
					onClick={editDefaultApproversModal.onOpen}
					data-cy="edit-workspace-default-approvers-button"
				/>
				<Button
					icon={<Icon name="Edit" />}
					size="xxs"
					variant="ghost"
					onClick={editWorkspaceModal.onOpen}
				/>
			</RowActionsWrapper>
			{editDefaultApproversModal.isOpen && (
				<EditDefaultApproversModal
					workspaceId={cell.row.original.id}
					name={cell.row.original.name}
					isOpen={editDefaultApproversModal.isOpen}
					onClose={editDefaultApproversModal.onClose}
				/>
			)}
			{editWorkspaceModal.isOpen && (
				<EditWorkspaceModal
					workspaceId={cell.row.original.id}
					isOpen={editWorkspaceModal.isOpen}
					onClose={editWorkspaceModal.onClose}
				/>
			)}
		</React.Fragment>
	);
}
